import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-inner-page" }
const _hoisted_2 = { class: "container mx-auto p-4 pb-10 md:p-8 lg:p-10" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" « Voltar ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "inner-page-titles" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Primeira Fase"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "CNH"),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SOCIAL 2023")
], -1)
const _hoisted_5 = { class: "flex h-auto flex-wrap gap-3 py-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "h-14 w-full rounded-full bg-yellow-500 px-3 py-2 leading-5 hover:bg-yellow-600" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-800" }, " Relação Geral ")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "h-14 w-full rounded-full bg-yellow-400 bg-opacity-60 px-3 py-2 leading-5 hover:bg-yellow-500" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-800" }, "Selecionados por município")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "text-xl leading-none" }
const _hoisted_11 = {
  id: "relacao-geral",
  class: "mb-4 pt-12"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", { class: "mb-3 self-center uppercase" }, [
  /*#__PURE__*/_createTextVNode(" Relação geral de candidatos "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "selecionados")
], -1)
const _hoisted_13 = { class: "mb-3 flex flex-wrap justify-between bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "self-center uppercase" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Capital")
], -1)
const _hoisted_15 = { class: "mb-3 flex flex-wrap justify-between bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "self-center uppercase" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Interior")
], -1)
const _hoisted_17 = {
  id: "por-municipio",
  class: "mb-4 pt-12"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", { class: "mb-3 self-center uppercase" }, [
  /*#__PURE__*/_createTextVNode(" Relação de candidatos "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "selecionados"),
  /*#__PURE__*/_createTextVNode(" por município ")
], -1)
const _hoisted_19 = { class: "self-center uppercase" }
const _hoisted_20 = ["textContent"]
const _hoisted_21 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menu),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "mb-5 inline-block rounded-full bg-yellow-400 px-5 py-3 font-bold"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "flex w-40 items-center justify-center",
          href: "#relacao-geral",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackClick('Button', '1ª Fase 2023 - Relação Geral')))
        }, _hoisted_7),
        _createElementVNode("a", {
          href: "#por-municipio",
          class: "flex w-40 items-center justify-center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackClick('Button', '1ª Fase 2023 - Relação por municípios')))
        }, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("ul", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("li", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("a", {
              href: "/files/primeira-fase-2023/CNHSOCIAL_01_2023_LISTA_GERAL_CAPITAL.pdf",
              target: "_blank",
              class: "inline-block rounded bg-yellow-400 px-5 py-2 uppercase",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackClick('Download', '1F2023 - Baixar PDF Selecionados - Capital')))
            }, " Baixar pdf ")
          ]),
          _createElementVNode("li", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("a", {
              href: "/files/primeira-fase-2023/CNHSOCIAL_01_2023_LISTA_GERAL_INTERIOR.pdf",
              target: "_blank",
              class: "inline-block rounded bg-yellow-400 px-5 py-2 uppercase",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackClick('Download', '1F2023 - Baixar PDF Selecionados - Interior')))
            }, " Baixar pdf ")
          ])
        ]),
        _createElementVNode("ul", _hoisted_17, [
          _hoisted_18,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.municipios, (municipio) => {
            return (_openBlock(), _createElementBlock("li", {
              key: municipio,
              class: "mb-3 flex items-center justify-between gap-3 bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3"
            }, [
              _createElementVNode("p", _hoisted_19, [
                _createElementVNode("span", {
                  class: "font-bold",
                  textContent: _toDisplayString(municipio.nome)
                }, null, 8, _hoisted_20)
              ]),
              _createElementVNode("a", {
                href: municipio.link,
                target: "_blank",
                class: "inline-block whitespace-nowrap rounded bg-yellow-400 px-5 py-2 uppercase",
                onClick: ($event: any) => (_ctx.trackClick('Download', `1F2023 - Baixar PDF Selecionados - ${municipio.nome}`))
              }, " Baixar pdf ", 8, _hoisted_21)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}